import { RUBIK_FONT_STACK } from "../utils/fontStack";

const FORM_FONT_SIZE = "0.875rem"; // 14
const FORM_LINE_HEIGHT = "21px";

const formFieldTypography = {
  fontSize: FORM_FONT_SIZE,
  fontWeight: 400,
  lineHeight: FORM_LINE_HEIGHT,
};

const typography = {
  fontFamily: RUBIK_FONT_STACK,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  lineHeight: "22px",
  body1: {
    fontSize: "0.875rem", // 14
    fontWeight: 400,
    lineHeight: "17px",
  },
  h1: {
    fontSize: "1.25rem", // 24
    fontWeight: 500,
    lineHeight: "29px",
  },
  h2: {
    fontSize: "1.25rem", // 20
    fontWeight: 600,
    lineHeight: "24px",
  },
  h3: {
    fontSize: "1rem", // 16
    fontWeight: 500,
    lineHeight: "19px",
  },
  h3Bold: {
    fontSize: "1rem", // 16
    fontWeight: 600,
    lineHeight: "22px",
  },
  text: {
    fontSize: "1rem", // 16
    fontWeight: 500,
    lineHeight: "22px",
  },
  textBig: {
    fontSize: "2rem", // 32
    fontWeight: 700,
    lineHeight: "44px",
  },
  textBold: {
    fontSize: "1rem", // 16
    fontWeight: 700,
    lineHeight: "17px",
  },
  textSemiBold: {
    fontSize: "1rem", // 16
    fontWeight: 600,
    lineHeight: "17px",
  },
  textMedium: {
    fontSize: "1rem", // 16
    fontWeight: 400,
    lineHeight: "17px",
  },
  textSmall: {
    fontSize: "0.75rem", // 12
    fontWeight: 400,
    lineHeight: "15px",
  },
  textTiny: {
    fontSize: "0.625rem", // 10
    fontWeight: 500,
    lineHeight: "12px",
  },
  number: {
    fontSize: "1.25rem", // 20
    fontWeight: 500,
    lineHeight: "22px",
  },
  button: {
    fontSize: "1rem", // 16
    textTransform: "none",
  },
  bigButton: {
    fontSize: "0.9375rem", // 15px need this size???
    textTransform: "none",
  },
  caption: {
    fontSize: "1rem", // 16
  },
  captionBold: {
    fontSize: "1.125rem", // 18
    fontWeight: 500,
  },
  sidebar: {
    fontSize: "0.9375rem", // 15px need this size???
  },
  tableHeader: {
    fontWeight: 500,
    fontSize: "0.9375rem", // 15px need this size???
  },
  modalCaption: {
    fontSize: "1rem", // 16
    fontWeight: 400,
    lineHeight: "22px",
  },
  menu: {
    fontSize: "1.125rem", // 18
    fontWeight: 500,
    lineHeight: "22px",
  },
  menuSemiBold: {
    fontSize: "1.25rem", // 20
    fontWeight: 600,
    lineHeight: "22px",
  },
  menuSmall: {
    ...formFieldTypography,
  },
  menuTiny: {
    fontSize: "0.5rem", // 8
    fontWeight: 400,
    lineHeight: 11,
    letterSpacing: 0,
    textAlign: "left",
  },
  input: {
    ...formFieldTypography,
  },
  formField: {
    ...formFieldTypography,
  },
};

export default typography;
